export default {
  title: 'Actions',
  description: 'Gestion des actions pour la réponse aux incidents',
  create: 'Créer une action',
  noResults: 'Aucune action trouvée',
  stats: {
    total: 'Total',
    pending: 'En attente',
    inProgress: 'En cours',
    completed: 'Terminées',
    overdue: 'En retard'
  },
  filters: {
    status: 'Statut',
    priority: 'Priorité',
    type: 'Type'
  },
  fields: {
    title: 'Titre',
    status: 'Statut',
    priority: 'Priorité',
    type: 'Type',
    progress: 'Progression',
    assignedTo: 'Assigné à',
    dueDate: 'Échéance',
    description: 'Description',
    incident: 'Incident lié'
  },
  status: {
    pending: 'En attente',
    in_progress: 'En cours',
    completed: 'Terminée',
    cancelled: 'Annulée'
  },
  priority: {
    low: 'Faible',
    medium: 'Moyenne',
    high: 'Élevée',
    critical: 'Critique'
  },
  type: {
    corrective: 'Corrective',
    preventive: 'Préventive',
    improvement: 'Amélioration'
  },
  sort: {
    'createdAt-desc': 'Plus récentes',
    'createdAt-asc': 'Plus anciennes',
    'dueDate-desc': 'Échéance (Plus tardive)',
    'dueDate-asc': 'Échéance (Plus proche)',
    'priority-desc': 'Priorité (Élevée à Faible)',
    'priority-asc': 'Priorité (Faible à Élevée)',
    'progress-desc': 'Progression (Élevée à Faible)',
    'progress-asc': 'Progression (Faible à Élevée)'
  },
  kanban: {
    noActions: 'Aucune action'
  },
  view: {
    list: 'Vue liste',
    kanbanStatus: 'Kanban par statut',
    kanbanPriority: 'Kanban par priorité'
  }
}
